import './swiper.scss';
import './material-slider.scss';
import { createElementFromHTML } from '../../utilities/js/helper';
// import Swiper from 'swiper/bundle';
import Swiper, { Lazy, Navigation, Manipulation } from 'swiper';
import { Observer } from '../../services/observer';
import { SliderSwitcher } from '../../services/slider-switch';
import { CookieHandler } from '../../utilities/js/cookie-handler';
import { Overlay } from '../../components/overlay/overlay';
// import { ActionHandler } from '../../services/action-handler';

class MaterialSlider {
    constructor (el) {
        this.$module = el;
        this.$switcher = null;
        this.$allSlides = this.$module.querySelectorAll('[data-material-slider="button"]');
        this.switcher = null;
        this.$overviewSlide = this.$module.querySelector('[data-material-slider="overview-slider"]');
        this.$favButton = this.$module.querySelector('[data-material-slider="fav-button"]');
        // this.actions = this.$module.querySelectorAll('[data-action]');

        this.slider = null;
        this.startTime = null;
        this.loader = document.createElement('span');
        this.loader.classList.add('loading');
        this.observer = new Observer();
        this.cookieHandler = CookieHandler();
        this.summaryHandler = null;
        this.actionHandler = null;
        this.isLoading = false;
        this.variantIsLoading = false;
        this.frontColorNames = document.querySelectorAll('[data-front-color-name]');
        if (typeof window.summaryHandler !== 'undefined') {
            this.summaryHandler = window.summaryHandler;
        }
    }

    initialize () {
        //  init slider switcher
        this.$switcher = this.$module.querySelector('[data-slider-switch]');
        if (this.$switcher !== null) {
            this.switcher = new SliderSwitcher(this.$switcher);
        }

        this.createSlider(this.$module);
        this.bindEvents(this.$module);
        this.setActiveSlide();
        this.setFavUrl(this.$favButton.classList.contains('is--active'));

        // this.actions.forEach((action) => {
        //     this.actionHandler = new ActionHandler(action);
        // });
    }

    createSlider () {
        const $module = this.$module;

        const $materialSlider = $module.querySelector('[data-material-slider="slider"]');

        this.slider = new Swiper($materialSlider, {
            modules: [Lazy, Navigation, Manipulation],
            slidesPerView: 5,
            spaceBetween: 30,
            speed: 800,
            resistance: true,
            resistanceRatio: 0,
            preloadImages: false,
            watchSlidesProgress: true,
            lazy: {
                loadPrevNext: true
            },
            breakpoints: {
                1200: {
                    slidesPerView: 4
                },
                992: {
                    slidesPerView: 3
                },
                767: {
                    slidesPerView: 'auto',
                    // centeredSlides: true,
                    spaceBetween: 15
                }
            },
            navigation: {
                nextEl: '.material-slider__next',
                prevEl: '.material-slider__prev'
            }
        });
    }

    bindEvents () {
        this.bindSlideEvents();

        // BIND SLIDER SWITCH EVENTS
        // when clicked on the switch, the slider will disappear, by moving out of the container
        if (this.$switcher !== null) {
            this.$switcher.addEventListener('switched', () => {
                this.moveSliderOut();
                this.startTime = new Date().getTime();
                this.loading(this.$module, 'show');
            });

            // change slider slides and move slider back to view, when json is loaded
            this.$switcher.addEventListener('dataReady', () => {
                // got the data, do stuff
                const endTime = this.startTime + 600;
                const interval = setInterval(() => {
                    if (new Date().getTime() > endTime) {
                        const data = this.switcher.receivedData;

                        if (data) {
                            // only do this, when no error occurred
                            this.removeSlides();
                            this.addSlides(data);
                            this.changeOverviewSlideContent(data);
                            this.bindSlideEvents();
                            this.handleObserverUrl(data.observerUrl);
                            this.setActiveSlide();

                            const $activeSlide = this.$module.querySelector('.material-slider__slide--selected');

                            if ($activeSlide) {
                                const mobileImage = $activeSlide.getAttribute('data-mobile-image');
                                const desktopImage = $activeSlide.getAttribute('data-desktop-image');
                                const imageData = {
                                    mobile: mobileImage,
                                    desktop: desktopImage
                                };
                                const descriptionText = $activeSlide.querySelector('[data-material-slider="tag"]').textContent;
                                this.handleDescriptionText(descriptionText);
                                this.handleBackgroundImage(imageData);

                                // set new data tmp for hover preview
                                const $dataTmp = this.$module.querySelector('[data-tmp]');
                                if ($dataTmp) {
                                    $dataTmp.setAttribute('data-tmp', desktopImage);
                                }
                            }

                            const activeFavorite = data.imageData.find(item => item.id === +$activeSlide.dataset.materialId)?.isFavorite;
                            console.log(activeFavorite);
                            this.setFavUrl(activeFavorite);
                        }

                        this.moveSliderIn();
                        this.loading(this.$module, 'hide');
                        clearInterval(interval);
                    }
                }, 100);
            });
        }
    }

    bindSlideEvents () {
        this.$allSlides = this.$module.querySelectorAll('[data-material-slider="button"]');
        // function to add click event
        const addClick = ($button) => {
            $button.addEventListener('click', (e) => {
                const $slide = e.target;
                if (!$slide.classList.contains('material-slider__slide--selected')) {
                    // define data extracted from the clicked slide
                    this.setCookie($slide); // important set cookie before ajax

                    // make ajax
                    // because we don't know which working top is active
                    this.handleAjax($slide);

                    this.changeOnlinePlannerUrl();
                }
            });
        };

        // bind mouse events
        const addMouseEnter = ($button) => {
            $button.addEventListener('mouseenter', (e) => {
                const $slide = e.currentTarget;
                // only toggle hover image, when it is not an selected slide
                if (!$slide.classList.contains('material-slider__slide--selected')) {
                    this.setHoverImage($slide);
                }

                if (!$slide.classList.contains('material-slider--has-tag')) {
                    this.handleTagVisibility(e);
                }
            });
        };
        const addMouseLeave = ($button) => {
            $button.addEventListener('mouseleave', (e) => {
                const $slide = e.currentTarget;
                if (!$slide.classList.contains('material-slider__slide--selected')) {
                    this.removePreviewImage($slide);
                }

                this.handleTagVisibility(e);
            });
        };

        // bind event on slide/button
        const $buttons = this.$allSlides;
        for (let i = 0; i < $buttons.length; i++) {
            const $button = $buttons[i];
            addClick($button);
            if (document.documentElement.classList.contains('csshover')) {
                addMouseEnter($button);
                addMouseLeave($button);
            }
        }
    }

    handleSlideState ($slide) {
        const $curElement = $slide;
        const $slides = this.$allSlides;
        for (let i = 0; i < $slides.length; i++) {
            const $curSlide = $slides[i];
            if ($curSlide === $curElement) {
                $curSlide.classList.add('material-slider__slide--selected');
                $curSlide.classList.add('material-slider--has-tag');
            } else {
                $curSlide.classList.remove('material-slider__slide--selected');
                $curSlide.classList.remove('material-slider--has-tag');
            }
        }
    }

    handleBackgroundImage (imageData) {
        const $activeContainer = this.$module.querySelector('.material-slider__background-figure.active');
        const $passiveContainer = this.$module.querySelector('.material-slider__background-figure.passive');

        const imageSourceMobile = imageData.mobile;
        const imageSourceDesktop = imageData.desktop;

        const $image = $passiveContainer.querySelector('img');
        if ($image) {
            // wait until image is loaded
            $image.onload = () => {
                // swap classes
                $activeContainer.classList.remove('active');
                $activeContainer.classList.add('passive');
                $passiveContainer.classList.remove('passive');
                $passiveContainer.classList.add('active');
            };

            $image.setAttribute('src', imageSourceDesktop);
        }

        const $source = $passiveContainer.querySelector('source');
        if ($source) {
            $source.setAttribute('srcset', imageSourceMobile);
        }
    }

    handleDescriptionText (text) {
        const $description = this.$module.querySelector('[data-material-slider="description"]');
        $description.textContent = text;
    }

    changeFrontColorNames (color) {
        const head = document.querySelector('head');
        const preline = document.querySelector('.intro__preline').innerHTML;
        const activeSwitch = document.querySelector('.slider-switch__link--active').getAttribute('data-switch-item');

        if (activeSwitch === 'fronten') {
            for (let index = 0; index < this.frontColorNames.length; index++) {
                this.frontColorNames[index].innerHTML = color;
            }

            if (preline) {
                head.querySelector('title').innerHTML = preline.substr(0, preline.indexOf('<span')) + ' ' + color + ' - Küche&Co';
            }
        }
    }

    // move the slider out of the container to hide it
    moveSliderOut () {
        const $slider = this.$module.querySelector('[data-material-slider="slider"]');
        $slider.classList.add('material-slider__slider--out');
    }

    // move the slide back into the container
    moveSliderIn () {
        const $slider = this.$module.querySelector('[data-material-slider="slider"]');
        $slider.classList.remove('material-slider__slider--out');
    }

    removeSlides () {
        const numberOfSlides = this.slider.slides.length;

        if (numberOfSlides > 0) {
            const slideIndex = [];

            for (let i = 0; i < numberOfSlides - 1; i++) {
                slideIndex.push(i);
            }

            this.slider.removeSlide(slideIndex);
        }
    }

    addSlides (data) {
        const imageData = data.imageData;
        const jsonLength = imageData.length;
        const slideArray = [];
        // const itemType = data.observerUrl.replace(/slider|\//g, '');

        for (let i = jsonLength - 1; i >= 0; i--) {
            const currentData = imageData[i];

            if (currentData.image[0] !== null) {
                const imagePreview = currentData.image.preview;
                let imageMobile = currentData.image.mobile;
                let imageDesktop = currentData.image.desktop;
                const imageKitchen = currentData.image.kitchen;
                const imageNav = currentData.image.nav;
                const variantId = currentData.id;
                const description = currentData.description;

                if (typeof currentData.image.previewDesktop !== 'undefined') {
                    imageDesktop = currentData.image.previewDesktop;
                    imageMobile = currentData.image.previewMobile;
                }

                const slide =
                    '<div class="material-slider__slide swiper-slide"' +
                    ' data-material-slider="button" data-material-id="' + variantId + '"' +
                    ' data-kitchen-image="' + imageKitchen + '"' +
                    ' data-nav-image="' + imageNav + '"' +
                    ' data-mobile-image="' + imageMobile + '"' +
                    ' data-desktop-image="' + imageDesktop + '">' +
                    '<span class="material-slider__tag" data-material-slider="tag">' + description + '</span>' +
                    '<figure class="material-slider__slide-image"' +
                    ' data-material-slider="slider-image">' +
                    '<img src="' + imagePreview + '" alt="Material mit der id ' + variantId + '">' +
                    '</figure>' +
                    '</div>';

                slideArray.push(slide);
            }
        }

        this.slider.prependSlide(slideArray);
        this.slider.slideTo(0);
    }

    changeOverviewSlideContent (data) {
        const label = data.overviewLabel;
        const link = data.overviewLink;

        this.$overviewSlide.querySelector('span').textContent = label;
        this.$overviewSlide.setAttribute('href', link);
    }

    triggerPageChange (data) {
        this.observer.init(data.observerData);
    }

    loading ($sliderContainer, status) {
        const $images = document.querySelectorAll('[data-kitchen-variante-image]');
        const loader = '<span class="loading loading--show"><b class="loader"><i>loading...</i></b></span>';
        const $loader = createElementFromHTML(loader);

        if (status === 'show') {
            if (this.variantIsLoading === false) {
                this.variantIsLoading = true;

                for (let showIndex = 0; showIndex < $images.length; showIndex++) {
                    // $images[showIndex].after((loader)[0]);
                    $images[showIndex].insertAdjacentElement('afterend', $loader);
                }
            }

            $sliderContainer.appendChild(this.loader);
            this.loader.classList.add('loading--show');
        }

        if (status === 'hide') {
            if (this.variantIsLoading === true) {
                this.variantIsLoading = false;

                for (let hideIndex = 0; hideIndex < $images.length; hideIndex++) {
                    const loadingEl = $images[hideIndex].parentNode.querySelector('.loading');
                    if (loadingEl) {
                        loadingEl.parentNode.removeChild(loadingEl);
                    }
                    // $images[hideIndex].parentNode.querySelector('.loading').remove();
                }
            }

            if (this.loader) {
                this.loader.classList.remove('loading--show');
                this.loader.parentNode.removeChild(this.loader);
            }
        }
    }

    removePreviewImage (e) {
        const $backgroundContainer = this.$module.querySelector('.material-slider__background');
        const activeImageUrl = $backgroundContainer.getAttribute('data-tmp');

        // create data json for handleBackgroundImage function to process
        const imageData = {
            mobile: activeImageUrl,
            desktop: activeImageUrl
        };
        // change bg
        this.handleBackgroundImage(imageData);
    }

    setHoverImage ($slide) {
        // create data object for handleBackgroundImage function to process
        const imageData = {
            mobile: $slide.getAttribute('data-mobile-image'),
            desktop: $slide.getAttribute('data-desktop-image')
        };
        // change bg
        this.handleBackgroundImage(imageData);
    }

    setTemporaryImageAttribute (source) {
        const $backgroundContainer = this.$module.querySelector('.material-slider__background');
        $backgroundContainer.setAttribute('data-tmp', source);
    }

    handleTagVisibility (e) {
        const eventType = e.type;
        const $allSlides = this.$allSlides;
        const $slide = e.target;

        if (eventType === 'mouseenter') {
            for (let i = 0; i < $allSlides.length; i++) {
                const $curSlide = $allSlides[i];
                if ($curSlide === $slide) {
                    $slide.classList.add('material-slider--has-tag');
                } else {
                    $curSlide.classList.remove('material-slider--has-tag');
                }
            }
        }

        if (eventType === 'mouseleave') {
            const $selectedSlide = this.$module.querySelector('.material-slider__slide--selected');
            for (let j = 0; j < $allSlides.length; j++) {
                const $curSlide2 = $allSlides[j];

                if ($selectedSlide === $curSlide2) {
                    $selectedSlide.classList.add('material-slider--has-tag');
                } else {
                    $curSlide2.classList.remove('material-slider--has-tag');
                }
            }
        }
    }

    setCookie ($slide) {
        const materialId = $slide.getAttribute('data-material-id');
        const activeSlider = this.$module.getAttribute('data-observer-url').replace(/slider|\//g, '');

        this.cookieHandler.setCookie(activeSlider + '-id', materialId);
    }

    handleObserverUrl (url) {
        this.$module.setAttribute('data-observer-url', url);
    }

    handleSummary ($slide) {
        if (this.summaryHandler !== null) {
            const text = $slide.querySelector('[data-material-slider="tag"]').textContent;
            let target = this.$module.querySelector('.slider-switch__link.slider-switch__link--active');
            if (target) {
                // get the slider type from the slide switcher attribute
                target = target.getAttribute('data-switch-item');
            } else {
                // get slider type from module data attr
                target = this.$module.getAttribute('data-material-slider-name');
            }

            this.summaryHandler.changeContent(target, text);
        }
    }

    setActiveSlide () {
        const activeSlider = this.$module.getAttribute('data-observer-url').replace(/slider|\//g, '');
        const slideId = this.cookieHandler.getCookie(activeSlider + '-id');
        const $activeSlide = this.$module.querySelector('[data-material-id="' + slideId + '"]');

        if (slideId !== '' && $activeSlide) {
            $activeSlide.classList.add('material-slider__slide--selected', 'material-slider--has-tag');
        }
    }

    handleAjax ($slide) {
        if (this.isLoading) {
            console.warn('still loading ...');
            return false;
        }
        this.isLoading = true;

        // create URL
        /*
            URL für klick auf slides im slider
            http://website.kueche.test/kueche/demo-kueche/slider/arbeitsplatten/
            http://website.kueche.test/kueche/demo-kueche/slider/fronten/
            http://website.kueche.test/kueche/demo-kueche/slider/korpus/
            -> standard url
            0/ -> index des slides
            slider/{typ}/{slideIndex}
         */
        // set fixed index, because it does not matter anymore (cookies handle the active slide)
        const url = this.$module.getAttribute('data-observer-url') + $slide.dataset.materialId;

        this.loading(this.$module, 'show');
        const request = new XMLHttpRequest();
        request.open('GET', url);

        request.addEventListener('load', (e) => {
            const data = JSON.parse(e.target.responseText);
            // todo set correct json key
            const imageMobile = $slide.getAttribute('data-mobile-image');
            const imageDesktop = $slide.getAttribute('data-desktop-image');
            let imageData = {
                mobile: imageMobile,
                desktop: imageDesktop
            };
            const $descriptionText = $slide.querySelector('[data-material-slider="tag"]');
            let descriptionText = '';

            if ($descriptionText) {
                descriptionText = $descriptionText.textContent;
            }

            let kitchenImage;
            let navigationImage;

            const status = data.imageData[0].isFavorite;
            const message = data.message;

            if (data.observerData[0].target === 'front') {
                kitchenImage = data.observerData[1].image.desktop;
                navigationImage = data.observerData[1].image.nav;
                imageData = data.observerData[0].image;
            } else {
                kitchenImage = data.observerData[0].image.desktop;
                navigationImage = data.observerData[0].image.nav;
            }

            // handle active slide and background image after
            // ajax load is done
            this.loading(this.$module, 'hide');
            this.handleSlideState($slide);
            this.handleBackgroundImage(imageData);
            this.handleDescriptionText(descriptionText);
            this.setTemporaryImageAttribute(imageData.desktop);
            const $tag = $slide.querySelector('[data-material-slider="tag"]');

            if ($tag) {
                this.changeFrontColorNames($tag.innerHTML.trim());
            }

            if (message == null) {
                this.changePageHeaderImage(kitchenImage);
                this.changeNavigationImage(navigationImage);
                this.changePanoramaImage(kitchenImage);
            } else {
                this.createOverlayMessage(message);
            }

            this.handleSummary($slide);
            this.setFavUrl(status);
            this.isLoading = false;
        });

        request.addEventListener('error', (e) => {
            console.warn('loading error: ', e);
            this.isLoading = false;
        });

        request.send();
    }

    createOverlayMessage (message) {
        const $overlay = document.createElement('div');
        const overlayInner = '<div class="overlay__inner"><div data-overlay-scroller><div class="overlay__content" data-overlay-content><p>' + message + '</p>' +
            '</div></div><a role="button" class="action overlay__close" data-overlay-close><i>close</i></a>' +
            '</div></section>';

        $overlay.classList.add('overlay');
        $overlay.setAttribute('data-overlay', '');
        $overlay.innerHTML = overlayInner;

        document.querySelector('body').insertBefore($overlay, document.querySelector('body').lastElementChild);
        const $$overlay = new Overlay($overlay);
        $$overlay.initialize();

        setTimeout(() => {
            $overlay.classList.add('overlay--open');
        }, 250);
    }

    changePageHeaderImage (imageSource) {
        if (imageSource !== null) {
            const $picture = document.querySelector('.heroimage picture');
            $picture.innerHTML = '<img src="' + imageSource + '" alt="Pageheader Kitchen preview image">';

            // change href in panorama button
            const $panoButton = document.querySelector('.heroimage [data-panorama]');
            if ($panoButton) {
                $panoButton.setAttribute('data-href', imageSource);
            }
        }
    }

    changeNavigationImage (imageSource) {
        if (imageSource !== null) {
            const $images = document.querySelectorAll('[data-kitchen-variante-image]');

            for (let i = 0; i < $images.length; i++) {
                $images[i].src = imageSource;
            }
        }
    }

    changePanoramaImage (imageSource) {
        if (imageSource !== null) {
            const $panoramaLink = document.querySelector('[data-panorama]');
            $panoramaLink.setAttribute('data-href', imageSource);
        }
    }

    setFavUrl (status) {
        const activeSlider = this.$module.getAttribute('data-observer-url').replace(/slider|\//g, '');
        const slideId = this.cookieHandler.getCookie(activeSlider + '-id');

        if (this.$favButton) {
            this.$favButton.setAttribute('data-href', '/inspiration/ideenbuch/produkt-merken/' + activeSlider + '/' + slideId);
            if (typeof status !== 'undefined') {
                if (status) {
                    this.$favButton.classList.add('is--active');
                } else {
                    this.$favButton.classList.remove('is--active');
                }
            } else {
                this.$favButton.classList.remove('is--active');
            }
        }
    }

    changeOnlinePlannerUrl () {
        const $opLink = document.querySelector('[data-op-params-action]');

        if ($opLink) {
            const action = $opLink.getAttribute('data-op-params-action');
            const method = 'GET';

            const request = new XMLHttpRequest();
            request.open(method, action, true);

            request.onload = () => {
                if (this.status >= 200 && this.status < 400) {
                    // Success!
                    const data = JSON.parse(this.response);
                    if (data.success === true) {
                        $opLink.href = data.url;
                    }
                } else {
                    console.warn('We reached our target server, but it returned an error');
                }
            };

            request.onerror = () => {
                // There was a connection error of some sort
                console.warn('could not fetch online planner parameter url');
            };

            request.send();
        }
    }
}

export { MaterialSlider };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$materialSlider = $context.querySelectorAll('[data-material-slider="root"]');
        for (let i = 0; i < $$materialSlider.length; i++) {
            const $materialSlider = new MaterialSlider($$materialSlider[i]);
            $materialSlider.initialize();
        }
    }
});
